import { useState, useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../../../../store/hooks'
import { setOpenDropdown } from '../../../../../../../store/ui/uiSlice'
import { selectOpenDropdownId } from '../../../../../../../store/ui/uiSelectors'
import { useWorkspace } from '../../../../../../../contexts/WorkspaceContext'
import ButtonRound from '@/components/ui/ButtonRound/ButtonRound'
import DropdownWrapper from '@/components/ui/Dropdown/components/DropdownWrapper/DropdownWrapper'
import Dropdown from '../../../../../../ui/Dropdown/Dropdown'
import DropdownItem from '@/components/ui/Dropdown/components/DropdownItem/DropdownItem'
import DropdownDivider from '@/components/ui/Dropdown/components/DropdownDivider/DropdownDivider'
import StatusColorSquare from './components/StatusColorSquare/StatusColorSquare'

interface TaskModalStatusProps {
    statusId: string
    onStatusChange?: (statusId: string) => void
}

const DROPDOWN_ID = 'task-modal-status'

const TaskModalStatus = ({ statusId, onStatusChange }: TaskModalStatusProps) => {
    const dispatch = useAppDispatch()
    const openDropdownId = useAppSelector(selectOpenDropdownId)
    const [isDropdownOpen, setIsDropdownOpen] = useState(false)

    const { statuses } = useWorkspace()
    // TODO: remove fallback when task creation always sets statusId
    const currentStatus = statuses.find(s => s.id === statusId)
        ?? statuses.find(s => s.systemType === 'todo')

    useEffect(() => {
        const shouldBeOpen = openDropdownId === DROPDOWN_ID
        if (isDropdownOpen !== shouldBeOpen) {
            setIsDropdownOpen(shouldBeOpen)
        }
    }, [openDropdownId, isDropdownOpen])

    const handleStatusClick = (newStatusId: string) => {
        onStatusChange?.(newStatusId)
        dispatch(setOpenDropdown(null))
    }

    const handleButtonClick = () => {
        dispatch(setOpenDropdown(isDropdownOpen ? null : DROPDOWN_ID))
    }

    const handleClose = () => {
        dispatch(setOpenDropdown(null))
    }

    if (!currentStatus) {
        return null
    }

    return (
        <DropdownWrapper>
            <ButtonRound
                color={currentStatus.color}
                onClick={handleButtonClick}
            >
                {currentStatus.name}
            </ButtonRound>
            <Dropdown isOpen={isDropdownOpen} onClose={handleClose}>
                <DropdownItem title="Set status..." disabled={true} />
                <DropdownDivider />
                {statuses.map((status) => (
                    <DropdownItem
                        key={status.id}
                        icon={<StatusColorSquare color={status.color} />}
                        title={status.name}
                        onClick={() => handleStatusClick(status.id)}
                    />
                ))}
            </Dropdown>
        </DropdownWrapper>
    )
}

export default TaskModalStatus
